import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../../../api';

const DynamicBreadcrumb = () => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const slug = location.pathname.replace(/^\/|\/$/g, '');

    if (!slug) return;

    api.get(`/api/breadcrumb/${slug}`)
      .then(res => {
        if (res.data?.success) {
          setBreadcrumbs(res.data.data.breadcrumbs || []);
        } else {
          setBreadcrumbs([]);
        }
      })
      .catch(() => setBreadcrumbs([]));

  }, [location.pathname]);

  if (!breadcrumbs.length) return null;

  return (
    <>
      <nav
        className="banner-breadcrumb"
        aria-label="Breadcrumb"
      >
        {breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1;

          return (
            <span
              key={index}
              aria-current={isLast ? 'page' : undefined}
            >
              {item.link && !isLast ? (
                <Link to={item.link}>
                  {item.title}
                </Link>
              ) : (
                <span className="active">
                  {item.title}
                </span>
              )}

              {index < breadcrumbs.length - 1 && (
                <span> / </span>
              )}
            </span>
          );
        })}
      </nav>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: breadcrumbs.map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.title,
            item: item.link
              ? `${window.location.origin}${item.link}`
              : window.location.href
          }))
        })}
      </script>
    </>
  );
};

export default DynamicBreadcrumb;
